<template>
  <div class="access-control-inout-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card class="tree-card">
          <ul class="tree-list">
            <li v-for="(item, index) in openTypeCds" :key="index" @click="switchOpenType(item)"
              :class="{ 'selected': conditions.openTypeCd === item.value }">
              {{ item.label }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="search-card">
          <div slot="header" class="flex justify-between">
            <span>开门记录查询</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-select v-model="conditions.machineId"
                placeholder="选择设备" style="width:100%" clearable>
                <el-option v-for="item in accessControls" :key="item.machineId"
                  :label="item.machineName" :value="item.machineId" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-input v-model="conditions.name"
                placeholder="姓名" />
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top:15px">
            <el-col :span="6">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="table-card" style="margin-top:20px">
          <div slot="header" class="flex justify-between">
            <span>开门记录</span>
          </div>
          <el-table :data="records" border style="width:100%" v-loading="loading">
            <el-table-column prop="name" label="姓名" align="center" width="100" />
            <el-table-column prop="machineName" label="设备名称" align="center" />
            <el-table-column prop="machineCode" label="设备SN" align="center" />
            <el-table-column prop="openTypeName" label="开门方式" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.openTypeName || getOpenTypeName(scope.row.openTypeCd) }}
              </template>
            </el-table-column>
            <el-table-column prop="fileTime" label="开门时间" align="center" width="180" />
            <el-table-column prop="fileId" label="抓拍照片" align="center" width="100">
              <template slot-scope="scope">
                <el-image v-if="scope.row.facePath" style="width:60px;height:60px;cursor:pointer"
                  :src="scope.row.facePath" :preview-src-list="[scope.row.facePath]" fit="cover" />
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top:20px;text-align:right" :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]" :page-size="page.size" :total="page.total"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listAccessControlInouts, listAccessControls } from '@/api/machine/accessControlInoutApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AccessControlInoutList',
  data() {
    return {
      loading: false,
      communityId: '',
      accessControls: [],
      records: [],
      openTypeCds: [
        { label: '全部', value: '' },
        { label: '人脸', value: '1001' },
        { label: '刷卡', value: '1002' },
        { label: '远程开门', value: '1007' }
      ],
      conditions: {
        machineId: '',
        name: '',
        openTypeCd: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.loadDevices()
    this.loadRecords()
  },
  methods: {
    async loadRecords() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          communityId: this.communityId,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listAccessControlInouts(params)
        this.records = data
        this.page.total = total
      } catch (error) {
        console.error('获取开门记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    async loadDevices() {
      try {
        const { data } = await listAccessControls({ communityId: this.communityId })
        this.accessControls = data
      } catch (error) {
        console.error('获取设备列表失败:', error)
      }
    },
    handleSearch() {
      this.page.current = 1
      this.loadRecords()
    },
    switchOpenType(item) {
      this.conditions.openTypeCd = item.value
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.loadRecords()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadRecords()
    },
    getOpenTypeName(openTypeCd) {
      if (!openTypeCd) return ''
      const map = { '0': '其他', '1001': '人脸', '1004': '人脸', '1002': '刷卡', '1007': '远程开门' }
      return map[openTypeCd] || '其他'
    }
  }
}
</script>

<style lang="scss" scoped>
.access-control-inout-container {
  padding: 20px;

  .tree-card {
    height: 100%;

    .tree-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 10px;
        cursor: pointer;
        text-align: center;
        margin-bottom: 5px;
        border-radius: 4px;

        &:hover {
          background-color: #f5f7fa;
        }

        &.selected {
          background-color: #409eff;
          color: #fff;
        }
      }
    }
  }

  .search-card {
    margin-bottom: 20px;
  }
}
</style>
